<template>
  <div v-if="!isEmpty" class="user-listing-detail">
    <div class="Head-div p-3 d-flex justify-content-between align-items-center border-bottom">
      <h4 class="mb-0">Pharmacy Center Details</h4>
      <div class="cursor" @click.stop="$emit('close')">
        <crossSVG />
      </div>
    </div>
    <CCol sm="12" class="px-0 inner-scroller">
      <CCol sm="12" class="user-profile-info border-bottom">
        <div class="media">
          <div class="media-body">
            <h3 class="mt-0 font-weight-normal text-capitalize">{{ centerInfo.general.name }}</h3>
            <p class="mb-1">
              <span class="text-dark">Email :</span>
              {{
              centerInfo.general.contact_email
              ? centerInfo.general.contact_email
              : "&#8213;"
              }}
            </p>
            <p class="mb-1">
              <span class="text-dark">Mobile :</span>
              {{
              centerInfo.general.contact_number
              ? centerInfo.general.contact_number
              : "&#8213;"
              }}
            </p>
          </div>
          <div>
            <v-btn color="red" dark>Deactivate</v-btn>
            <div class="mt-2">
              <span class="font-weight-bold">Referral Code:</span>
              {{
              centerInfo &&
              centerInfo.created_by &&
              centerInfo.created_by.reference_code &&
              centerInfo.created_by.reference_code.code
              ? centerInfo.created_by.reference_code.code
              : "&#8213;"
              }}
            </div>
          </div>
        </div>
      </CCol>
      <!-- .... end user-profile-info ... -->
      <CCol sm="12" class="px-0 pb-0">
        <CCol sm="12" class="pt-0 border-bottom">
          <h6 class="mb-0 text-dark">Owner Details</h6>
        </CCol>
        <CCol v-if="centerInfo && centerInfo.created_by" sm="12" class="border-bottom">
          <CRow>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0">Name :</p>
              <p>{{ centerInfo.created_by.full_name }}</p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0">Gender :</p>
              <p>{{ centerInfo.created_by.gender }}</p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0">Date of birth :</p>
              <p>
                 {{
                centerInfo.created_by.dob
                ? dayJS(centerInfo.created_by.dob).format(
                formats.date_format
                )
                : "&#8213;"
                }}
              </p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0">Age :</p>
              <p>{{age(centerInfo.created_by)
                }}</p>
            </CCol>
          </CRow>
        </CCol>
      </CCol>
      <CCol sm="12" class="px-0">
        <!-- .... General Info ... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="pt-0 border-bottom">
            <h6 class="mb-0 text-dark">General Details</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Accreditations :</p>
                <p>
                  {{
                  centerInfo.general.accreditations.length > 0
                  ? centerInfo.general.accreditations.join(", ")
                  : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Centre existing since :</p>
                <p>
                  {{
                  centerInfo.general.since
                  ? centerInfo.general.since
                  : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Description :</p>
                <p>
                  {{
                  centerInfo.general.bio ? centerInfo.general.bio : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Member of RelifeMS :</p>
                <p>{{ centerInfo.general.is_relife_member ? "Yes" : "No" }}</p>
              </CCol>
              <CCol sm="6" md="3">
                <p class="text-dark mb-0">Member of Panel Of Expert :</p>
                <p>{{ centerInfo.general.panel_of_expert ? "Yes" : "No" }}</p>
              </CCol>
            </CRow>
            <CRow>
              <CCol
                sm="6"
                md="3"
                @click="
                  centerInfo.general.cover_image
                    ? openModal(centerInfo.general.cover_image, 'Certificate')
                    : null
                "
              >
                <p class="text-dark mb-0">Cover Image :</p>
                <div class="file-attachment d-flex align-items-center">
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor">
                    {{
                    centerInfo.general.cover_image
                    ? centerInfo.general.cover_image.split("/").pop()
                    : "&#8213;"
                    }}
                  </p>
                </div>
              </CCol>
              <CCol
                sm="6"
                md="3"
                v-for="(img, i) in centerInfo.general.center_images"
                :key="i"
                @click="img ? openModal(img, 'Certificate') : null"
              >
                <p class="text-dark mb-0">Pharmacy Pictures {{ i + 1 }} :</p>
                <div class="file-attachment d-flex align-items-center">
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor">{{ img ? img.split("/").pop() : "&#8213;" }}</p>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- .... End General Info ... -->
<!-- ================================== -->
<!-- centre details start -->
      <CCol v-if="centerInfo.staff_details.first_name" sm="12" class="p-0">
        <CCol sm="12" class="border-bottom">
          <h6 class="mb-0 text-dark">Staff Details</h6>
        </CCol>
        <CCol sm="12" class="border-bottom">
          <CRow>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0"> Staff Name </p>
              <p>{{centerInfo.staff_details.first_name +" "+centerInfo.staff_details.last_name}}</p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0"> Staff UserID</p>
              <p>{{centerInfo.staff_details.user_id }}</p>
            </CCol>
            <CCol sm="6" md="2">
              <p class="text-dark mb-0"> Staff Mobile number</p>
              <p>
               {{centerInfo.staff_details.mobile }}
              </p>
            </CCol>
          </CRow>
        </CCol>
      </CCol>
<!-- centre details end -->      
<!-- ================================== -->
        <!-- .... Pharmacy Info ... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Pharmacy Info</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Time :</p>
                <p v-if="centerInfo.pharmacy && centerInfo.pharmacy.only_day">
                  Day {{ centerInfo.pharmacy.open_time }} to
                  {{ centerInfo.pharmacy.close_time }}
                </p>
                <p v-else>Day & Night</p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Weekly Off:</p>
                <p>
                  {{
                  centerInfo.pharmacy.weekly_off.length > 0
                  ? centerInfo.pharmacy.weekly_off.join(", ")
                  : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Generic Store</p>
                <p>{{ centerInfo.pharmacy.is_generic_store ? "Yes" : "No" }}</p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Only Online, No Retail</p>
                <p>{{ centerInfo.pharmacy.only_online ? "Yes" : "No" }}</p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Pharmacy Ownership</p>
                <p>
                  {{
                  centerInfo.pharmacy.type_of_pharmacy
                  ? centerInfo.pharmacy.type_of_pharmacy
                  : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Type of pharmacy</p>
                <p>
                  {{
                  centerInfo.pharmacy.type_of_medicine
                  ? centerInfo.pharmacy.type_of_medicine
                  : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Home Deliver</p>
                <p>
                  {{
                  centerInfo.pharmacy.is_available_for_home_services
                  ? "Yes"
                  : "No"
                  }}
                </p>
              </CCol>
            </CRow>
            <CRow>
              <CCol v-if=" centerInfo.pharmacy.service_area > 0 "  sm="6" md="2">
                <p class="text-dark mb-0">Area of Coverage</p>
                <p>
                  {{
                  centerInfo.pharmacy.service_area < 10 && centerInfo.pharmacy.service_area > 0
                  ? "Less than 10 KM"
                  : "Upto 10 KM"
                  }}
                </p>
              </CCol>
              <CCol sm="6" md="2">
                <p class="text-dark mb-0">Government Certificate Number</p>
                <p>
                  {{
                  centerInfo.pharmacy.registration_number
                  ? centerInfo.pharmacy.registration_number
                  : "&#8213;"
                  }}
                </p>
              </CCol>
              <CCol
                sm="6"
                md="3"
                @click="
                  centerInfo.pharmacy.registration_proof_image
                    ? openModal(
                        centerInfo.pharmacy.registration_proof_image,
                        'Certificate'
                      )
                    : null
                "
              >
                <p class="text-dark mb-0">Certificate :</p>
                <div class="file-attachment d-flex align-items-center">
                  <fileSVG />
                  <p class="ml-2 mb-0 cursor">
                    {{
                    centerInfo.pharmacy.registration_proof_image
                    ? centerInfo.pharmacy.registration_proof_image
                    .split("/")
                    .pop()
                    : "&#8213;"
                    }}
                  </p>
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- .... End Pharmacy Info ... -->
        <!-- ...... Address Info ...... -->
        <CCol sm="12" class="p-0">
          <CCol sm="12" class="border-bottom">
            <h6 class="mb-0 text-dark">Address Info</h6>
          </CCol>
          <CCol sm="12" class="border-bottom">
            <CRow>
              <CCol sm="6" md="4">
                <p class="text-dark mb-0">Center address :</p>
                <p>
                  {{
                  centerInfo.general.address.address_line_two
                  ? centerInfo.general.address.address_line_two
                  : "&#8213;"
                  }}
                </p>
              </CCol>
            </CRow>
          </CCol>
        </CCol>
        <!-- ...... end Address Info ...... -->
      </CCol>
    </CCol>

    <image-preview
      @close="closeImageModal"
      v-if="openImageModal"
      :openImageModal="openImageModal"
      :source="fileUrl"
      :fileArcheType="fileArcheType"
    ></image-preview>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import "@/assets/scss/_userDetails.scss";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .build();
import formats from "@/formats";
export default {
  props: ["centerId"],
  data() {
    return {
      centerInfo: {},
      isEmpty: true,
      openImageModal: false,
      fileUrl: "",
      fileArcheType: "",
      dayJS,
      formats
    };
  },
  components: {
    "light-box-new": () => import("@/components/lightBoxNew.vue"),
    "image-view": () => import("@/components/image.vue"),
    "image-preview": () => import("@/components/modals/imagePreview.vue"),
    ...pickSvg("crossSVG", "fileSVG"),
    loader: () => import("@/components/loader.vue")
  },

  mounted() {
    this.getPharmacyDetails();
  },
  methods: {
    age(data) {
      let date= data.dob && data.dob != null ? data.dob : data.estimated_dob
      return dayJS(new Date() ).diff(date,'year')
    },
    closeImageModal() {
      this.openImageModal = false;
    },
    openModal(fileUrl, fileArcheType) {
      this.fileUrl = fileUrl;
      this.fileArcheType = fileArcheType;
      this.openImageModal = true;
    },
    getPharmacyDetails() {
      this.$store.commit("general/setLoader", true);
      let role = "pharmacy";
      let url = `${config.BASE_URL}api/v2/admin/centers/${this.centerId}/profile?role=${role}`;
      this.$http.get(url).then(response => {
        if (response.body.status) {
          this.$store.commit("general/setLoader", false);
          this.centerInfo = response && response.body && response.body.data;
          this.isEmpty = false;
        } else {
          this.$store.commit("general/setLoader", false);
          this.isEmpty = true;
        }
      });
    }
  }
};
</script>